// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__YrDCW","header":"PatientBlock_header__1GpMT","label":"PatientBlock_label__1PYoM","option":"PatientBlock_option__3qEnX"};